import { render, staticRenderFns } from "./BusinessEntitiesRegister.vue?vue&type=template&id=1a8e7e76&scoped=true&"
import script from "./BusinessEntitiesRegister.vue?vue&type=script&lang=js&"
export * from "./BusinessEntitiesRegister.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEntitiesRegister.vue?vue&type=style&index=0&id=1a8e7e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e7e76",
  null
  
)

export default component.exports